import request from "@/utils/request";

//根据sectionCode获取对应的门店
function getStoreItem(sectionCode) {
    return request.get(`/cms/section/${sectionCode}`)
}
//获取所有门店
function getStoreList() {
    return request.get('/cms/section/ac_channels')
}
export default {
    getStoreItem,
    getStoreList
}